import React from 'react'

import cn from 'classnames'
import { IWrapperProps } from './interface'
import './styles.scss'

const bc = 'reports-wrapper'

const Wrapper: React.FC<IWrapperProps> = ({ children, marginBottom = '20px', isClosed = false, style = {} }) => {
  return (
    <div className={cn(bc, { [`${bc}__closed`]: isClosed })} style={{ marginBottom, ...style }}>
      {children}
    </div>
  )
}

export default Wrapper
